<template>
  <div style="height: 100%;width: 100%;overflow: hidden;">
    <StandardSearchPageView
      ref="table"
      rowKey="orderTaskId"
      :col="3"
      :columns="getColumns()"
      :queryParams="queryParams"
      :searchOptions="searchOptions"
      :requestPromise="loadDataList"
    >
    </StandardSearchPageView>
  </div>
</template>

<script>
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'

export default {
  name: 'OrderRecordsComponent',
  components: {
    StandardSearchPageView
  },
  data () {
    return {
      queryParams: {},
      searchOptions: [
        {
          name: '订单编号',
          key: 'orderTaskId',
          type: 'input',
          placeholder: '请输入'
        },
        {
          name: '代理通订单ID',
          key: 'dltOrderId',
          type: 'input',
          placeholder: '请输入'
        },
        {
          name: '酒店名称',
          key: 'hotelName',
          type: 'input',
          placeholder: '请输入'
        },
        {
          name: '下单日期',
          key: 'orderStartDate,orderEndDate',
          type: 'rangePicker'
        }
      ]
    }
  },
  methods: {
    loadDataList (params) {
      const requestParams = {
        ...params,
        ...params.limitDto,
        limitDto:undefined,
        merchantId: this.$store.getters.userInfo.merchantId
      }
      return this.getHttpServices().getSourceService().post('pushXC/order-records/page', requestParams)
    },
    getColumns () {
      return [
        {
          title: '订单编号',
          dataIndex: 'orderTaskId',
          width: '140px'
        },
        {
          title: '代理通订单ID',
          dataIndex: 'dltOrderId',
          width: '160px'
        },
        {
          title: '酒店名称',
          dataIndex: 'hotelName',
          width: '280px'
        },
        {
          title: '订单状态',
          dataIndex: 'orderStateName',
          width: '120px'
        },
        {
          title: '来源',
          dataIndex: 'source',
          width: '160px'
        },
        {
          title: '下单时间',
          dataIndex: 'orderTime',
          width: '180px'
        }
      ]
    }
  }
}
</script>

<style scoped></style>
